import React from "react";
import { Form, Select, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Booking } from "../../../types/booking";

const { Option } = Select;

interface BookingSelectorProps {
  bookings: Booking[];
  onBookingChange: (value: number) => void;
  isEditMode: boolean;
  getBookingDisplayName: (booking: Booking) => string;
}

const BookingSelector: React.FC<BookingSelectorProps> = ({
  bookings,
  onBookingChange,
  isEditMode,
  getBookingDisplayName,
}) => {
  return (
    <Form.Item
      name="booking_id"
      label={
        <span>
          Booking{" "}
          <Tooltip title="Select a booking to generate invoice lines automatically based on pricing rules that match the booking's transport type, origin, destination, weight, and volume.">
            <QuestionCircleOutlined style={{ cursor: "pointer" }} />
          </Tooltip>
        </span>
      }
      rules={[{ required: true, message: "Please select a booking" }]}
    >
      <Select
        placeholder="Select a booking"
        onChange={onBookingChange}
        optionFilterProp="children"
        showSearch
        filterOption={(input, option) =>
          (option?.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        loading={bookings.length === 0}
        disabled={isEditMode}
      >
        {bookings.map((booking) => (
          <Option key={booking.id} value={booking.id}>
            {getBookingDisplayName(booking)}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default BookingSelector;
